<template>
  <div class="space-y-10 divide-y divide-gray-900/10">
    <div class="grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3">
      <div class="px-4 sm:px-0">
        <h2 class="text-base font-semibold leading-7 text-gray-900">Create Score Content</h2>
        <p class="mt-1 text-sm leading-6 text-gray-600">Score Content Text Prompt</p>
      </div>

      <Form v-slot="{ handleSubmit, errors}" :validation-schema="schema" class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
        <button v-if="scoreContentId" @click="destroy" type="button" class="rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 m-3">
          <TrashIcon class="h-5 w-5" aria-hidden="true" />
        </button>
        <div class="px-4 py-6 sm:p-8">
          <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">

            <div class="sm:col-span-5">
              <label for="question_set" class="block text-sm font-medium leading-6 text-gray-900">
                Score
                <span class="text-red-600 text-sm">*</span>
              </label>
              <div class="mt-2">
                <Field @change="onChangeScoreLabel($event)" v-model="formData.score_label" v-bind:class="{ 'ring-red-600': errors.score_label }" as="select" name="score_label" id="score_label" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
                  <option value="" disabled>Select Score</option>
                  <option v-for="(value, key) in scoreLabels" :value="key"
                          v-bind:selected="key === formData.score_label">
                    {{ key }}
                  </option>
                </Field>
                <ErrorMessage class="mt-2 text-xs text-red-600" name="score_label" />
              </div>
            </div>

            <div class="sm:col-span-5" hidden="hidden">
              <label for="score_from" class="block text-sm font-medium leading-6 text-gray-400">
                Score from
                <span class="text-red-600 text-sm">*</span>
              </label>
              <div class="mt-2">
                <Field disabled="disabled" v-model="formData.score_from" v-bind:class="{ 'ring-red-600': errors.score_from }" type="number" name="score_from" id="score_from" placeholder="Score from" class="block w-full rounded-md border-0 py-1.5 text-gray-400 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                <ErrorMessage class="mt-2 text-xs text-red-600" name="score_from" />
              </div>
            </div>

            <div class="sm:col-span-5" hidden="hidden">
              <label for="score_to" class="block text-sm font-medium leading-6 text-gray-400">
                Score to
                <span class="text-red-600 text-sm">*</span>
              </label>
              <div class="mt-2">
                <Field disabled="disabled" v-model="formData.score_to" v-bind:class="{ 'ring-red-600': errors.score_to }" type="number" name="score_to" id="score_to" placeholder="Score to" class="block w-full rounded-md border-0 py-1.5 text-gray-400 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                <ErrorMessage class="mt-2 text-xs text-red-600" name="score_to" />
              </div>
            </div>

            <div class="col-span-full">
              <label for="content" class="block text-sm font-medium leading-6 text-gray-900">
                Content
                <span class="text-red-600 text-sm">*</span>
              </label>
              <div class="mt-2">
                <TrixComponent v-if="editorView" :id="editorId" :text="formData.content" @dataFromTrix="getDataFromTrix"></TrixComponent>
                <Field v-model="formData.content" v-bind:class="{ 'ring-red-600': errors.content }" as="textarea" name="content" id="content" hidden="hidden"/>
                <ErrorMessage class="mt-2 text-xs text-red-600" name="content" />
              </div>
              <p class="mt-3 text-sm leading-6 text-gray-600">Text Prompt</p>
            </div>

          </div>
        </div>

        <div class="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
          <button @click="cancel" type="button" class="text-sm font-semibold leading-6 text-gray-900">Cancel</button>
          <button v-if="scoreContentId" @click="handleSubmit($event, update)" type="button" class="rounded-md network-bg-color px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">Update</button>
          <button v-else @click="handleSubmit($event, create)" type="button" class="rounded-md network-bg-color px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">Save</button>
        </div>

      </Form>
    </div>
  </div>
</template>

<script>
import { TrashIcon } from '@heroicons/vue/24/solid'
import TrixComponent from "../../TrixComponent.vue";

export default {
  name: "QuestionSectionScoreContentCreateEditFormComponent",
  data() {
    return {
      formData: {
        score_from: null,
        score_to: null,
        content: null,
        score_label: null,
      },
      editorId: "content",
      editorView: false,
      scoreLabels: [],
    }
  },
  components: {
    TrixComponent,
    TrashIcon,
  },
  computed: {
    questionSectionId() {
      return this.$route.params.question_section_id ? parseInt((this.$route.params.question_section_id)) : null;
    },
    scoreContentId() {
      return this.$route.params.id ? parseInt((this.$route.params.id)) : null;
    },
    schema() {
      return yup.object({
        score_from: yup.number().required().label('Score from'),
        score_to: yup.number().required().label('Score from'),
        content: yup.string().required().min(3).label('Content'),
        score_label: yup.string().required().label('Score label'),
      });
    },
  },
  methods: {
    getScoreContentLabels() {
      axios.get(`/member-firm/form-data/question-section-score-content/score-labels`).then((res) => {
        this.scoreLabels = res.data.data;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    getScoreContent() {
      axios.get(`/member-firm/question-section-score-content/${this.questionSectionId}/edit/${this.scoreContentId}`).then((res) => {
        this.formData.score_from = res.data.data.score_from;
        this.formData.score_to = res.data.data.score_to;
        this.formData.content = res.data.data.content;
        this.formData.score_label = res.data.data.score_label;
        this.editorView = true;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    update() {
      axios.put(`/member-firm/question-section-score-content/${this.questionSectionId}/update/${this.scoreContentId}`, this.formData)
          .then((res) => {
            this.$notify({ type: "success", title: "Successfully", text: res.data.message });
            this.$router.back();
          })
          .catch((error) => {
            console.log('error', error);
            this.$notify({ title: "Unsuccessfully", text: error.message });
          });
    },
    create() {
      axios.post(`/member-firm/question-section-score-content/${this.questionSectionId}/store`, this.formData)
          .then((res) => {
            this.$notify({ type: "success", title: "Successfully", text: res.data.message });
            this.$router.back();
          })
          .catch((error) => {
            console.log('error', error);
            this.$notify({ title: "Unsuccessfully", text: error.message });
          });
    },
    cancel() {
      this.$router.back();
    },
    destroy() {
      if(confirm("Do you really want to delete?")) {
        axios.delete(`/member-firm/question-section-score-content/${this.questionSectionId}/destroy/${this.scoreContentId}`).then((res) => {
          this.$router.back();
        }).catch((error) => {
          console.log('error', error)
        })
      }
    },
    onChangeScoreLabel(event) {
      this.formData.score_from = this.scoreLabels[event.target.value][0] ?? null;
      this.formData.score_to = this.scoreLabels[event.target.value][1] ?? null;
    },
    getDataFromTrix: function(data) {
      this.formData.content = data;
    },
  },
  created() {
    this.getScoreContentLabels();
    if (this.scoreContentId) {
      this.getScoreContent();
    } else {
      this.editorView = true;
    }
  }
}
</script>